import React from "react";
import { Layout, Row, Col } from "antd";
import HeaderNavigationContainer from "../../components/HeaderNavigation/container";
import FeaturedArticles from "../../components/FeaturedArticles";
import BlogBlock from "../../components/BlogBlock";
import CarouselContainer from "./carouselContainer";
import BackgroundBlock from "../../components/BackgroundBlock";
import FooterContainer from "../../components/Footer/container";
import { getBackgroundImage } from "../../infrastructure/helpers/getBackgroundImage"
import signature from "../../assets/signature.png";
import circles from "../../assets/circles.png";
import intl from "./intl";

const { Header, Content } = Layout;
function Home(props) {

  return (
    <Layout
      className="layout homebg"
      style={{
        background: `url(${getBackgroundImage('front')}) black`,
        backgroundRepeat: "no-repeat",
        // backgroundSize: '100%',
        backgroundPosition: "50% 50px",
        backgroundSize: "100%"
      }}
    >
      <HeaderNavigationContainer />
      <Header className="">
        <div
          style={{
            color: "#fff",
            position: "relative",
            width: "100%",
            bottom: 0,
            marginTop: "15%"
          }}
        >
          <div className="header_headline" style={{ color: "#1abc9c" }}>
            <span style={{ opacity: 0 }}>Are you looking for a job?</span>
            <div className="header_headline_quote">
              {intl.headlineQuote[props.language]}
            </div>
          </div>

          <div className="home_header_info">
            <div
              style={{
                marginLeft: "-44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <div
                style={{
                  lineHeight: "20px",
                  display: "inline-block",
                  textAlign: "right",
                  padding: "10px 20px",
                  borderRight: "1px solid #1ABC9C"
                }}
              >
                Institute of Leadership Dynamics A/S
                <br />
                CVR 26 59 57 38
                <br />
                {intl.contactinfo.location[props.language]}
              </div>
              <div
                style={{
                  lineHeight: "20px",
                  display: "inline-block",
                  padding: "10px 50px"
                }}
              >
                <span style={{ color: "#1abc9c  " }}>
                  {intl.contactinfo.openHours[props.language]}
                </span>
                <br />
                24/7/364
                <br />
              </div>
              <div
                style={{
                  lineHeight: "20px",
                  display: "inline-block",
                  textAlign: "left",
                  padding: "10px 20px",
                  borderLeft: "1px solid #1ABC9C"
                }}
              >
                {intl.contactinfo.contact[props.language]}
                <br />
                <a href="mailto:info@leadershipdynamic.net">
                  info@leadershipdynamic.net
                </a>
                <br />
                +45 40 18 44 34
              </div>
            </div>
            <div>
              <button
                onClick={() => window.scrollBy(0, 700)}
                className="arrow_button_green"
              >
                <i className="arrow_green arrow_down" />
              </button>
            </div>
          </div>
        </div>
      </Header>
      <Content>
        <Row className="home_content_container">
          <Col md={24}>
            <h2 style={{ color: "#fff", paddingBottom: "30px" }}>
              {intl.block1.headline[props.language]}
            </h2>
          </Col>
          <Col md={{ span: 12, offset: 6 }}>
            <p>{intl.block1.body[props.language]}</p>
            <div>
              <img
                alt='home'
                src={signature}
                style={{
                  width: "200px",
                  paddingTop: "20px",
                  transform: "rotate(17deg)"
                }}
              />
            </div>
          </Col>
        </Row>
        <FeaturedArticles language={props.language} />
        <BlogBlock
          paddingContent="200px 0px 0px"
          img={circles}
          headline={intl.block3.headline[props.language]}
          body={intl.block3.body[props.language]}
          customClass="block_pull_up"
          language={props.language}
          readMoreLink="/our-tools#tools"
          buttonTxt={intl.block3.buttonTxt[props.language]}
          displayReadMore
          buttonType="submit"
          centerButton
        />
        <CarouselContainer />
        <BackgroundBlock
          subHeadline={intl.block5.subheadline[props.language]}
          headline={intl.block5.headline[props.language]}
        />
      </Content>
      <FooterContainer />
    </Layout>
  );
}
export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js